import "./Leads.css";
import React, { Fragment, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import LeadDeleteConfirmation from "./LeadDeleteConfirmation/LeadDeleteConfirmation";

// Form Validate imports Start
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// Form Validate imports End

// Controllers Start
import GetAllLeads from "../../controllers/leads/GetAllLeads";
import DeleteLead from "../../controllers/leads/DeleteLead";
import GetSingleLeadData from "../../controllers/leads/GetSingleLeadData";
// Controllers End

import GetSingleClient from "../../controllers/clients/GetSingleClient";
import ContentLoader from "../../components/Common/ContentLoader/ContentLoader";
import InfiniteScroll from "react-infinite-scroll-component";
import { ToastContainer } from "react-toastify";
import LeadForm from "../../components/LeadForm/LeadForm";
import ConfirmationModal from "../../components/Common/ConfirmationModal/ConfirmationModal";
import UserListCard from "../../components/UserListCard/UserListCard";
import FabButton from "../../components/FabButton/FabButton";
import NoDataFound from "../../components/Common/NoDataFound/NoDataFound";

// Form Validate schema Start
const schema = yup.object().shape({
  name: yup
    .string()
    .min(3, "Name must have atleast 3 characters")
    .required("Required"),
  phone: yup
    .string()
    .length(12, "Invalid phone number")
    .required("Required")
    .default("03"),
  email: yup.string().email("Invalid email!"),
  company: yup.string(),
  cnic: yup.string().max(15).default(""),
  address: yup.string(),
});
// Form Validate schema End

// Custom Style If There Are No Leads In Leads DataGrid Table Start
function CustomNoRowsOverlay() {
  return (
    <Fragment>
      <div className="leads-custom-nothing">
        <NoDataFound />
      </div>
    </Fragment>
  );
}
// Custom Style If There Are No Leads In Leads DataGrid Table End

const LEADS_LIMIT_PER_PACKET = 10;
// let unsubscribe;

const Leads = () => {
  // Form Validate const Start
  const {
    // register,
    // handleSubmit,
    reset,
    setValue,
    setError,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  // Form Validate const End
  // const [pageSize, setPageSize] = useState(10);
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [CNIC, setCNIC] = useState("");
  const [Refresh, setRefresh] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [leadsData, setLeadsData] = useState([]);
  const [refreshDOM, setRefreshDOM] = useState(false);
  const [RequestingLeads, setRequestingLeads] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const navigate = useNavigate();

  // Get All Leads useEffect Start
  const [hasMore, setHasMore] = useState(true);
  const [Year, setYear] = useState("*");
  const [Filter, setFilter] = useState("newest");
  const LastSnapshot = useRef("*");

  const fetchLeads = async (bottomFetching = true) => {
    let leadsArr = await GetAllLeads(
      Year,
      Filter,
      LastSnapshot.current,
      LEADS_LIMIT_PER_PACKET
    );

    if (leadsArr.leads.length < LEADS_LIMIT_PER_PACKET) setHasMore(false);

    LastSnapshot.current =
      leadsArr.leadsSnapshot.docs[leadsArr.leadsSnapshot.docs.length - 1];

    if (bottomFetching) setLeadsData([...leadsData, ...leadsArr.leads]);
    else setLeadsData([...leadsArr.leads]);
    setRequestingLeads(false);
  };

  const handleRefresh = () => {
    LastSnapshot.current = "*";
    setLeadsData([]);
    setRefresh(!Refresh);
  };

  useEffect(() => {
    fetchLeads(false);
    setRequestingLeads(true);
  }, [refreshDOM, Refresh, Year, Filter]);
  useEffect(() => handleRefresh(), [refreshDOM, Year, Filter]);

  // Get All Leads useEffect Start
  const [clientYear, setClientYear] = useState("*");
  // const [JoinedYear, setJoinedYear] = useState(new Date().setFullYear(2018));
  useEffect(() => {
    async function fetchData() {
      const client = await GetSingleClient();
      let clientCreatedAt = client.createdAt;
      clientCreatedAt = new Date(clientCreatedAt.toDate());
      setClientYear(clientCreatedAt);
    }
    fetchData();
  }, [refreshDOM, Refresh]);
  // Get All Leads useEffect End

  const [DeleteDialog, setDeleteDialog] = useState(false);
  const [DeleteLeadId, setDeleteLeadId] = useState("");
  const handleOpenDeleteDialog = (id) => {
    setDeleteLeadId(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteLead(DeleteLeadId);
      handleRefresh();
      setDeleteDialog(false);
    }
  };

  const [SingleLeadData, setSingleLeadData] = useState({});
  const [LeadId, setLeadId] = useState("");

  // Modal Start
  const [open, setOpen] = useState(false);
  const handleOpen = async (status, id) => {
    if (status === "add") {
      setOpen(status);
    } else {
      setLeadId(id);
      const leadData = await GetSingleLeadData(id);
      setSingleLeadData(leadData);

      setValue("name", leadData.name);
      setValue("phone", leadData.phone);
      setValue("email", leadData.email);
      setValue("company", leadData.company);
      setValue("cnic", leadData.cnic);
      setValue("address", leadData.address);
      setOpen(status);
    }
  };
  // Modal End

  //Check that is it mobile screen
  const [isMobile, setIsMobile] = useState(false);
  const setWindowDimensions = () => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  return (
    <>
      <div className="global-body-container leads-listing">
        <div className="custom-heading">Clients</div>
        <div className="leads-header-bar">
          <div className="search-bar">
            <div className="input-group">
              <input
                type="search"
                className="leads-search-input"
                placeholder="Enter name or mobile number"
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
              />
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                className="search-icon d-none d-xl-block"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.1592 16.0701L15.7962 12.7027C16.3057 11.5803 16.6115 10.4578 16.6115 9.2333C16.6115 6.98843 15.7962 4.94761 14.1656 3.417C10.9045 0.15169 5.70701 0.15169 2.44586 3.417C-0.815288 6.6823 -0.815288 11.8864 2.44586 15.1517C3.97452 16.6823 6.11465 17.6007 8.2548 17.6007C9.4777 17.6007 10.7006 17.2945 11.7197 16.7843L15.0828 20.1517C15.5924 20.6619 16.4076 20.968 17.121 20.968C17.8344 20.968 18.5478 20.6619 19.1592 20.1517C20.2803 18.9272 20.2803 17.0905 19.1592 16.0701ZM3.87261 13.519C1.42675 11.0701 1.42675 7.09047 3.87261 4.74353C5.09554 3.51904 6.6242 2.90679 8.2548 2.90679C9.8854 2.90679 11.414 3.51904 12.6369 4.74353C13.8599 5.96802 14.4713 7.49863 14.4713 9.1313C14.4713 10.7639 13.8599 12.3966 12.6369 13.519C11.414 14.6415 9.8854 15.3558 8.2548 15.3558C6.6242 15.3558 4.99363 14.7435 3.87261 13.519Z"
                  fill="#929292"
                />
              </svg>
            </div>
          </div>
          {!isMobile && (
            <button
              className="add-leads-button"
              onClick={() => {
                handleOpen("add", "");
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 17V7"
                  stroke="white"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
                <path
                  d="M7 12H17"
                  stroke="white"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
              </svg>{" "}
              Add Client
            </button>
          )}
        </div>

        <div className="row">
          <div className="col-12 ">
            <div className=" ">
              <div className=" ">
                <div className="table-responsive table-stripedd table-hoverr mt-2 ">
                  {!RequestingLeads && (
                    <InfiniteScroll
                      dataLength={leadsData.length} //This is important field to render the next data
                      next={fetchLeads}
                      hasMore={hasMore}
                      loader={
                        <div className="global-body-container h-100">
                          <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                          </div>
                        </div>
                      }
                      scrollThreshold={1.05}
                    >
                      {isMobile ? (
                        leadsData &&
                        leadsData
                          .filter((e) => {
                            if (searchValue == "") {
                              return e;
                            } else {
                              return (
                                e.name.toLowerCase().includes(searchValue) ||
                                e.phone.includes(searchValue)
                              );
                            }
                          })
                          .map((lead) => {
                            return (
                              <UserListCard
                                name={lead.name}
                                date={lead?.createdAt
                                  ?.toDate()
                                  ?.toLocaleString("en-GB", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  })}
                                phone={lead.phone}
                                email={lead.email}
                                cnic={lead.cnic}
                                address={lead.address}
                                onEdit={() => {
                                  handleOpen("update", lead.id);
                                }}
                                onClick={() =>
                                  navigate(`/user/leads/details/${lead.id}`)
                                }
                                onDelete={() => {
                                  handleOpenDeleteDialog(lead.id);
                                }}
                              />
                            );
                          })
                      ) : (
                        <table className="table table-borderless">
                          <thead>
                            <tr>
                              <th scope="col">
                                <span
                                  className="lead-name"
                                  style={{
                                    fontWeight: 500,
                                  }}
                                >
                                  Name
                                </span>
                                {/* <svg
                                  className="header-svg"
                                  width="12"
                                  height="15"
                                  viewBox="0 0 12 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.75 11.1893L9.4697 8.4697C9.7626 8.1768 10.2374 8.1768 10.5303 8.4697C10.8232 8.7626 10.8232 9.2374 10.5303 9.5303L6.5303 13.5303C6.2374 13.8232 5.7626 13.8232 5.4697 13.5303L1.46967 9.5303C1.17678 9.2374 1.17678 8.7626 1.46967 8.4697C1.76256 8.1768 2.23744 8.1768 2.53033 8.4697L5.25 11.1893V1.5C5.25 1.08579 5.5858 0.75 6 0.75C6.4142 0.75 6.75 1.08579 6.75 1.5V11.1893Z"
                                    fill="#404040"
                                    stroke="#404040"
                                  />
                                </svg> */}
                              </th>
                              <th scope="col">
                                <span
                                  style={{
                                    fontWeight: 500,
                                  }}
                                >
                                  Mobile
                                </span>
                                {/* <svg
                                  className="header-svg"
                                  width="12"
                                  height="15"
                                  viewBox="0 0 12 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.75 11.1893L9.4697 8.4697C9.7626 8.1768 10.2374 8.1768 10.5303 8.4697C10.8232 8.7626 10.8232 9.2374 10.5303 9.5303L6.5303 13.5303C6.2374 13.8232 5.7626 13.8232 5.4697 13.5303L1.46967 9.5303C1.17678 9.2374 1.17678 8.7626 1.46967 8.4697C1.76256 8.1768 2.23744 8.1768 2.53033 8.4697L5.25 11.1893V1.5C5.25 1.08579 5.5858 0.75 6 0.75C6.4142 0.75 6.75 1.08579 6.75 1.5V11.1893Z"
                                    fill="#404040"
                                    stroke="#404040"
                                  />
                                </svg> */}
                              </th>
                              <th scope="col">
                                <span
                                  style={{
                                    fontWeight: 500,
                                  }}
                                >
                                  Address
                                </span>
                                {/* <svg
                                  className="header-svg"
                                  width="12"
                                  height="15"
                                  viewBox="0 0 12 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5.25 3.8107L2.5303 6.5303C2.2374 6.8232 1.7626 6.8232 1.4697 6.5303C1.1768 6.2374 1.1768 5.7626 1.4697 5.4697L5.4697 1.4697C5.7626 1.1768 6.2374 1.1768 6.5303 1.4697L10.5303 5.4697C10.8232 5.7626 10.8232 6.2374 10.5303 6.5303C10.2374 6.8232 9.76256 6.8232 9.46967 6.5303L6.75 3.8107L6.75 13.5C6.75 13.9142 6.4142 14.25 6 14.25C5.5858 14.25 5.25 13.9142 5.25 13.5L5.25 3.8107Z"
                                    fill="#404040"
                                    stroke="#404040"
                                  />
                                </svg> */}
                              </th>
                              <th scope="col">
                                <span
                                  style={{
                                    fontWeight: 500,
                                  }}
                                >
                                  Email
                                </span>
                                {/* <svg
                                  className="header-svg"
                                  width="12"
                                  height="15"
                                  viewBox="0 0 12 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.75 11.1893L9.4697 8.4697C9.7626 8.1768 10.2374 8.1768 10.5303 8.4697C10.8232 8.7626 10.8232 9.2374 10.5303 9.5303L6.5303 13.5303C6.2374 13.8232 5.7626 13.8232 5.4697 13.5303L1.46967 9.5303C1.17678 9.2374 1.17678 8.7626 1.46967 8.4697C1.76256 8.1768 2.23744 8.1768 2.53033 8.4697L5.25 11.1893V1.5C5.25 1.08579 5.5858 0.75 6 0.75C6.4142 0.75 6.75 1.08579 6.75 1.5V11.1893Z"
                                    fill="#404040"
                                    stroke="#404040"
                                  />
                                </svg> */}
                              </th>
                              <th scope="col">
                                <span
                                  style={{
                                    fontWeight: 500,
                                  }}
                                >
                                  Company
                                </span>
                                {/* <svg
                                  className="header-svg"
                                  width="12"
                                  height="15"
                                  viewBox="0 0 12 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.75 11.1893L9.4697 8.4697C9.7626 8.1768 10.2374 8.1768 10.5303 8.4697C10.8232 8.7626 10.8232 9.2374 10.5303 9.5303L6.5303 13.5303C6.2374 13.8232 5.7626 13.8232 5.4697 13.5303L1.46967 9.5303C1.17678 9.2374 1.17678 8.7626 1.46967 8.4697C1.76256 8.1768 2.23744 8.1768 2.53033 8.4697L5.25 11.1893V1.5C5.25 1.08579 5.5858 0.75 6 0.75C6.4142 0.75 6.75 1.08579 6.75 1.5V11.1893Z"
                                    fill="#404040"
                                    stroke="#404040"
                                  />
                                </svg> */}
                              </th>
                              <th scope="col">
                                <span
                                  style={{
                                    fontWeight: 500,
                                  }}
                                >
                                  CNIC
                                </span>
                                {/* <svg
                                  className="header-svg"
                                  width="12"
                                  height="15"
                                  viewBox="0 0 12 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.75 11.1893L9.4697 8.4697C9.7626 8.1768 10.2374 8.1768 10.5303 8.4697C10.8232 8.7626 10.8232 9.2374 10.5303 9.5303L6.5303 13.5303C6.2374 13.8232 5.7626 13.8232 5.4697 13.5303L1.46967 9.5303C1.17678 9.2374 1.17678 8.7626 1.46967 8.4697C1.76256 8.1768 2.23744 8.1768 2.53033 8.4697L5.25 11.1893V1.5C5.25 1.08579 5.5858 0.75 6 0.75C6.4142 0.75 6.75 1.08579 6.75 1.5V11.1893Z"
                                    fill="#404040"
                                    stroke="#404040"
                                  />
                                </svg> */}
                              </th>
                              <th
                                scope="col"
                                className="header-action-container"
                              >
                                <span
                                  className="header-action-title"
                                  style={{
                                    fontWeight: 500,
                                  }}
                                >
                                  Action
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {leadsData &&
                              leadsData
                                .filter((e) => {
                                  if (searchValue == "") {
                                    return e;
                                  } else {
                                    return (
                                      e.name
                                        .toLowerCase()
                                        .includes(searchValue) ||
                                      e.phone.includes(searchValue)
                                    );
                                  }
                                })
                                .map((lead) => {
                                  return (
                                    <Fragment>
                                      <tr
                                        onClick={() =>
                                          navigate(
                                            `/user/leads/details/${lead.id}`
                                          )
                                        }
                                      >
                                        <th
                                          scope="row"
                                          style={{
                                            fontWeight: 500,
                                          }}
                                        >
                                          {lead.name}

                                          <br />
                                          <div className="alignment">
                                            <small className="add-on">
                                              Added on:
                                            </small>

                                            <small>
                                              {lead?.createdAt
                                                ?.toDate()
                                                ?.toLocaleString("en-GB", {
                                                  year: "numeric",
                                                  month: "short",
                                                  day: "numeric",
                                                })}
                                            </small>
                                          </div>
                                        </th>
                                        <td>{lead.phone}</td>
                                        <td className="text-truncate">
                                          {lead.address
                                            ? lead.address
                                            : "-------"}
                                        </td>
                                        <td>
                                          {lead.email ? lead.email : "-------"}
                                        </td>
                                        <td>
                                          {lead.company
                                            ? lead.company
                                            : "-------"}
                                        </td>
                                        <td>
                                          {lead.cnic ? lead.cnic : "-------"}
                                        </td>
                                        <td>
                                          <div className="edit-delete-svg">
                                            <span
                                              className="delete-svg-icon"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleOpenDeleteDialog(lead.id);
                                              }}
                                            >
                                              <svg
                                                width="35"
                                                height="35"
                                                viewBox="0 0 42 42"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <rect
                                                  width="42"
                                                  height="42"
                                                  rx="10"
                                                  fill="#EBEBEB"
                                                />
                                                <path
                                                  d="M18.7105 12.75L15.543 15.9262M24.293 12.75L27.4605 15.9262"
                                                  stroke="#FF0000"
                                                  strokeOpacity="0.7"
                                                  strokeWidth="1.5"
                                                  strokeMiterlimit="10"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />
                                                <path
                                                  d="M12.75 17.8672C12.75 16.2484 13.6162 16.1172 14.6925 16.1172H28.3075C29.3838 16.1172 30.25 16.2484 30.25 17.8672C30.25 19.7484 29.3838 19.6172 28.3075 19.6172H14.6925C13.6162 19.6172 12.75 19.7484 12.75 17.8672Z"
                                                  stroke="#FF0000"
                                                  strokeOpacity="0.7"
                                                  strokeWidth="1.5"
                                                />
                                                <path
                                                  d="M19.54 23.25V26.3562M23.565 23.25V26.3562M14.0625 19.75L15.2962 27.31C15.5762 29.0075 16.25 30.25 18.7525 30.25H24.0288C26.75 30.25 27.1525 29.06 27.4675 27.415L28.9375 19.75"
                                                  stroke="#FF0000"
                                                  strokeOpacity="0.7"
                                                  strokeWidth="1.5"
                                                  strokeLinecap="round"
                                                />
                                              </svg>
                                            </span>

                                            <span
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleOpen("update", lead.id);
                                              }}
                                            >
                                              <svg
                                                style={{ marginLeft: "5px" }}
                                                width="35"
                                                height="35"
                                                viewBox="0 0 42 42"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <rect
                                                  width="42"
                                                  height="42"
                                                  rx="10"
                                                  fill="#EBEBEB"
                                                />
                                                <path
                                                  opacity="0.8"
                                                  d="M12.8193 29.4326L12.8174 29.4307C12.7736 29.3871 12.75 29.344 12.75 29.25V26.425C12.75 26.388 12.7564 26.3538 12.7711 26.3172L12.7716 26.3159C12.7821 26.2896 12.7988 26.2619 12.8303 26.2303L22.6 16.4607L25.7893 19.65L16.0197 29.4197C15.9878 29.4516 15.96 29.4683 15.9345 29.4786C15.8967 29.4936 15.8618 29.5 15.825 29.5H13C12.906 29.5 12.8629 29.4764 12.8193 29.4326ZM28.2969 17.1175L25.1138 13.9719L25.9803 13.1053C26.2183 12.8674 26.4965 12.75 26.863 12.75C27.2286 12.75 27.5065 12.8672 27.7447 13.1053L29.1447 14.5053C29.393 14.7536 29.5146 15.0348 29.5254 15.3861C29.5356 15.7204 29.4318 15.9825 29.1947 16.2197L28.2969 17.1175Z"
                                                  stroke="black"
                                                  strokeOpacity="0.8"
                                                  strokeWidth="1.5"
                                                />
                                              </svg>
                                            </span>
                                          </div>
                                        </td>
                                      </tr>
                                    </Fragment>
                                  );
                                })}
                            {/* {leadsData &&
                              leadsData.map((lead) => {
                                return (
                                  <Fragment>
                                    <tr
                                      onClick={() =>
                                        navigate(
                                          `/user/leads/details/${lead.id}`
                                        )
                                      }
                                    >
                                      <th
                                        scope="row"
                                        style={{
                                          fontWeight: 500,
                                        }}
                                      >
                                        {lead.name}

                                        <br />
                                        <div className="alignment">
                                          <small className="add-on">
                                            Added on:
                                          </small>

                                          <small>
                                            {lead?.createdAt
                                              ?.toDate()
                                              ?.toLocaleString("en-GB", {
                                                year: "numeric",
                                                month: "short",
                                                day: "numeric",
                                              })}
                                          </small>
                                        </div>
                                      </th>
                                      <td>{lead.phone}</td>
                                      <td className="text-truncate">
                                        {lead.address
                                          ? lead.address
                                          : "-------"}
                                      </td>
                                      <td>
                                        {lead.email ? lead.email : "-------"}
                                      </td>
                                      <td>
                                        {lead.company
                                          ? lead.company
                                          : "-------"}
                                      </td>
                                      <td>
                                        {lead.cnic ? lead.cnic : "-------"}
                                      </td>
                                      <td>
                                        <div className="edit-delete-svg">
                                          <span
                                            className="delete-svg-icon"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleOpenDeleteDialog(lead.id);
                                            }}
                                          >
                                            <svg
                                              width="35"
                                              height="35"
                                              viewBox="0 0 42 42"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <rect
                                                width="42"
                                                height="42"
                                                rx="10"
                                                fill="#EBEBEB"
                                              />
                                              <path
                                                d="M18.7105 12.75L15.543 15.9262M24.293 12.75L27.4605 15.9262"
                                                stroke="#FF0000"
                                                strokeOpacity="0.7"
                                                stroke-width="1.5"
                                                stroke-miterlimit="10"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                              <path
                                                d="M12.75 17.8672C12.75 16.2484 13.6162 16.1172 14.6925 16.1172H28.3075C29.3838 16.1172 30.25 16.2484 30.25 17.8672C30.25 19.7484 29.3838 19.6172 28.3075 19.6172H14.6925C13.6162 19.6172 12.75 19.7484 12.75 17.8672Z"
                                                stroke="#FF0000"
                                                strokeOpacity="0.7"
                                                stroke-width="1.5"
                                              />
                                              <path
                                                d="M19.54 23.25V26.3562M23.565 23.25V26.3562M14.0625 19.75L15.2962 27.31C15.5762 29.0075 16.25 30.25 18.7525 30.25H24.0288C26.75 30.25 27.1525 29.06 27.4675 27.415L28.9375 19.75"
                                                stroke="#FF0000"
                                                strokeOpacity="0.7"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                              />
                                            </svg>
                                          </span>

                                          <span
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleOpen("update", lead.id);
                                            }}
                                          >
                                            <svg
                                              style={{ marginLeft: "5px" }}
                                              width="35"
                                              height="35"
                                              viewBox="0 0 42 42"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <rect
                                                width="42"
                                                height="42"
                                                rx="10"
                                                fill="#EBEBEB"
                                              />
                                              <path
                                                opacity="0.8"
                                                d="M12.8193 29.4326L12.8174 29.4307C12.7736 29.3871 12.75 29.344 12.75 29.25V26.425C12.75 26.388 12.7564 26.3538 12.7711 26.3172L12.7716 26.3159C12.7821 26.2896 12.7988 26.2619 12.8303 26.2303L22.6 16.4607L25.7893 19.65L16.0197 29.4197C15.9878 29.4516 15.96 29.4683 15.9345 29.4786C15.8967 29.4936 15.8618 29.5 15.825 29.5H13C12.906 29.5 12.8629 29.4764 12.8193 29.4326ZM28.2969 17.1175L25.1138 13.9719L25.9803 13.1053C26.2183 12.8674 26.4965 12.75 26.863 12.75C27.2286 12.75 27.5065 12.8672 27.7447 13.1053L29.1447 14.5053C29.393 14.7536 29.5146 15.0348 29.5254 15.3861C29.5356 15.7204 29.4318 15.9825 29.1947 16.2197L28.2969 17.1175Z"
                                                stroke="black"
                                                strokeOpacity="0.8"
                                                stroke-width="1.5"
                                              />
                                            </svg>
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  </Fragment>
                                );
                              })} */}
                          </tbody>
                        </table>
                      )}
                      {isMobile && (
                        <FabButton
                          onClick={() => {
                            handleOpen("add", "");
                          }}
                        />
                      )}

                      {leadsData.length === 0 && <CustomNoRowsOverlay />}
                    </InfiniteScroll>
                  )}
                  {RequestingLeads && <ContentLoader />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Fragment>
        <LeadForm
          {...{
            open,
            setOpen,
            SingleLeadData,
            setSingleLeadData,
            LeadId,
            handleRefresh,
          }}
        />
      </Fragment>

      {/* <LeadDeleteConfirmation
        {...{
          DeleteDialog,
          handleCloseDeleteDialog,
        }}
      /> */}

      <ConfirmationModal
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this client?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />

      <ToastContainer />
    </>
  );
};

export default Leads;
